import { render, staticRenderFns } from "./HealthInsuranceForm.vue?vue&type=template&id=2931422a"
import script from "./HealthInsuranceForm.vue?vue&type=script&lang=ts"
export * from "./HealthInsuranceForm.vue?vue&type=script&lang=ts"
import style0 from "./HealthInsuranceForm.vue?vue&type=style&index=0&id=2931422a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports